import { formatCurrency } from '@/utils/general/browserHelper'
import { Container, Typography } from '@cleartrip/ct-design-components'
import EmiBankProMsg from './EmiBankProMsg'

const EmiBankRatesSheet = ({
    planList,
    isOpen = false,
    processingFeeMsg = ''
}: {
    planList: any
    isOpen: boolean
    processingFeeMsg: string
}) => {
    const generateRowData = (plan_attributes: any = {}) => {
        const { interest_rate = 0, month = 0, monthly_value = 0, total_amount = 0 } = plan_attributes || {}
        const displayMonth = month.toString()
        const displayEMI = formatCurrency(Math.round(monthly_value))
        const displayInterest = Math.round(interest_rate) + '%'
        const displayTotal = formatCurrency(Math.round(total_amount))
        return [displayMonth, displayEMI, displayInterest, displayTotal]
    }
    const renderEmiListRow = (rowData: any = [], isHeading: boolean = false) => {
        return (
            <Container
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 1fr',
                    width: '100%',
                    height: '44px',
                    alignItems: 'center',
                    backgroundColor: isHeading ? '#F3F3F3' : '#FFFFFF'
                }}
            >
                {rowData.map((row: any) => {
                    const isZeroInterest = row === '0%'
                    return (
                        <Typography
                            className="ta-center"
                            variant={isHeading ? 'B3' : 'P2'}
                            color={isHeading ? 'subheading' : isZeroInterest ? 'success' : 'primary'}
                        >
                            {row}
                        </Typography>
                    )
                })}
            </Container>
        )
    }
    return (
        <Container
            style={{
                display: isOpen ? '' : 'none'
            }}
        >
            {renderEmiListRow(['MONTHS', 'EMI', 'INTEREST', 'TOTAL'], true)}
            {planList.map((plan: any) => {
                const { plan_attributes = {} } = plan || {}
                return renderEmiListRow(generateRowData(plan_attributes))
            })}
            <EmiBankProMsg msg={processingFeeMsg} />
        </Container>
    )
}

export default EmiBankRatesSheet
